const TVShowListItemComment = ({ comment }) => {
  return <li key={comment?.sid}>{comment?.comment}</li>;
};
export default TVShowListItemComment;
